import axios from 'axios';

import constants from '@/utils/constants.js';

let runtimeConfigPromise = null;

function applyRuntimeSettings(settings = {}) {
  if (Object.isFrozen(constants)) {
    return constants;
  }

  Object.keys(settings).forEach(key => {
    if (
      Object.prototype.hasOwnProperty.call(constants, key)
      || key.includes('_NAMESPACE')
      || key.includes('_VERSION')
      || key.includes('_ENABLED')
    ) {
      constants[key] = settings[key];
    }
  });

  Object.freeze(constants);
  return constants;
}

export async function bootstrapRuntimeConfig() {
  if (!runtimeConfigPromise) {
    runtimeConfigPromise = axios
      .get('configuration.json')
      .then(response => applyRuntimeSettings(response.data))
      .catch(error => {
        runtimeConfigPromise = null;
        throw error;
      });
  }

  return runtimeConfigPromise;
}

export { applyRuntimeSettings };
